export const SUBMIT_SHIPPING_REQUEST = 'SUBMIT_SHIPPING_REQUEST';
export const SUBMIT_SHIPPING_SUCCESS = 'SUBMIT_SHIPPING_SUCCESS';
export const SUBMIT_SHIPPING_FAILURE = 'SUBMIT_SHIPPING_FAILURE';
export const SUBMIT_ORDER_REQUEST = 'SUBMIT_ORDER_REQUEST';
export const SUBMIT_ORDER_SUCCESS = 'SUBMIT_ORDER_SUCCESS';
export const SUBMIT_ORDER_FAILURE = 'SUBMIT_ORDER_FAILURE';